import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("transcribely_token");
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const res = await api.get("/auth/me");
            setUser(res.data);
        } catch {
            localStorage.removeItem("transcribely_token");
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const setToken = (token, userData) => {
        localStorage.setItem("transcribely_token", token);
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem("transcribely_token");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, setToken, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
